import React, { useState } from 'react'
import { getMessage } from 'lib/translator'
import SelectModuleType from './SelectModuleType'
import DeleteModule from './DeleteModule'
import ModuleList from './ModuleList'
import Navigator from './Navigator'

const Layout = () => {
  const [popUp, setPopUp] = useState(null)

  return (
    <>
      <h1>{getMessage('app.layout.header')}</h1>
      <div className="layout-wrapper">
        <Navigator />
        <ModuleList setPopUp={setPopUp} />
        {popUp === 'module-type' && <SelectModuleType setPopUp={setPopUp} />}
        {popUp === 'delete-module' && <DeleteModule setPopUp={setPopUp} />}
      </div>
    </>
  )
}

export default Layout
